<div class="card flex justify-center flex min-h-screen">
    <p-progress-spinner ariaLabel="loading" [style]="{margin:'auto'}" />
</div>